/****************************************************
 * Module Name:  memoManageModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, TextField, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";

function MemoManageModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  sourceData,
  status,
  memoIds,
  loading
}) {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const prepareStoneData = (data) => {
    let stoneDataArray = [];
    sourceData.map((iData) => {
      if (iData.memoid === data && stoneId.includes(iData.stoneid)) {
        stoneDataArray.push({ id: iData.stoneid, status: iData.stonestatus, daymemo: iData.daymemo });
      }
      return stoneDataArray;
    });
    return stoneDataArray;
  };

  const handleArray = () => {
    let filteredData = memoIds.map((data) => {
      return {
        memoid: data,
        stones: prepareStoneData(data),
        oldstatus: "MEMO_OUT",
        newstatus: status,
        remark: remark,
      };
    });
    return filteredData;
  };

  const saveHandler = () => {
    let data = handleArray();
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            {status === "MEMO_RETURN"
              ? "Return"
              : status === "MEMO_SELL"
                ? "Sell"
                : "Sell Send"}{" "}
            Stones validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {status === "MEMO_RETURN"
              ? "Return"
              : status === "MEMO_SELL"
                ? "Sell"
                : "Sell Send"}{" "}
            Stones
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Typography variant="p" sx={{ mt: 2 }}>
              Remark
            </Typography>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{
            "& .Mui-disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12) !important",
              color: "rgba(0, 0, 0, 0.26) !important"
            }
          }}>
            <LoadingButton
              variant="contained"
              onClick={saveHandler}
              type="Submit"
              sx={{ mr: 3 }}
              loading={loading}
              loadingPosition="start"
              startIcon={status === "MEMO_RETURN" ? <KeyboardReturnIcon size="large" /> : <DiamondOutlinedIcon size="large" />}
            >
              {status === "MEMO_RETURN"
                ? "Return"
                : status === "MEMO_SELL"
                  ? "Sell"
                  : "Sell Send"}
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MemoManageModal;
